import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoanOdAccounts } from './loan-od-accounts.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';
@Injectable()
export class LoanOdAccountsPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private loanOdAccountsService: LoanOdAccountsService

    ) {}

    open(component: any, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.loanOdAccountsService.find(id).subscribe((loanOdAccounts) => {
                this.loanOdAccountsModalRef(component, loanOdAccounts);
            });
        } else {
            return this.loanOdAccountsModalRef(component, new LoanOdAccounts());
        }
    }

    loanOdAccountsModalRef(component: Component, loanOdAccounts: LoanOdAccounts): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.loanOdAccounts = loanOdAccounts;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}
